import { defineStyleConfig } from "@chakra-ui/react";

export const tagTheme = defineStyleConfig({
	defaultProps: {
		variant: "brand",
	},
	baseStyle: {
		container: {
			borderRadius: "md",
		},
	},
	variants: {
		brand: {
			container: {
				background: "brand.400",
				color: "neutrals.0",
			},
		},
		subtle: {
			container: {
				background: "neutrals.40",
				color: "neutrals.900",
			},
		},
		dark: {
			container: {
				background: "neutrals.200",
				color: "neutrals.0",
			},
		},
		green: {
			container: {
				background: "accent.green.100",
				color: "neutrals.900",
			},
		},
		orange: {
			container: {
				background: "accent.orange.100",
				color: "neutrals.900",
			},
		},
		red: {
			container: {
				background: "accent.red.400",
				color: "neutrals.0",
			},
		},
	},
});
